const jsxHelper = require('./jsx-helper');
const pugAsJsxLoader = require('./pug-as-jsx-loader');

module.exports = pugAsJsxLoader(jsxHelper(null));



// WEBPACK FOOTER //
// ./src/loader/browser.js